import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { InputComponent } from '@shared/form-elements/input/input/input.component';
import { ReactiveFormsModule } from '@angular/forms';

@UntilDestroy()
@Component({
    selector: 'app-input-zipcode',
    standalone: true,
    templateUrl: './input-zipcode.component.html',
    imports: [InputComponent, TranslateSafePipe, ReactiveFormsModule]
})
export class InputZipcodeComponent extends AbstractInputComponent implements OnInit {
    ngOnInit(): void {
        this.control.valueChanges.pipe(untilDestroyed(this)).subscribe((value: string | number) => {
            this.control.setValue(
                value
                    .toString()
                    .replace(/[^0-9]/g, '')
                    .substring(0, 4),
                { emitEvent: false }
            );
        });
    }
}
